const px = (n) => `${n}px`;

export const getInsightsPosition = (position, offsetWidth = 0, offsetHeight = 0, padding = 16) => {
    switch (position) {
        case 'top-right':
            return {
                top: px(padding),
                right: px(padding),
            };
        case 'top-middle':
            return {
                top: px(padding),
                left: `calc(50% + ${padding}px + ${offsetWidth}px)`,
            };
        case 'bottom-left':
            return {
                bottom: px(padding + offsetHeight),
                left: px(padding + offsetWidth),
            };
        case 'bottom-right':
            return {
                bottom: px(padding + offsetHeight),
                right: px(padding),
            };
        case 'top-left':
        default:
            return {
                top: px(padding),
                left: px(padding + offsetWidth),
            };
    }
};
